import * as types from '../constants'

export const defaultState = {
  library_controls: [],
  library_control: {},
  action_type: "",
  exception: "",
  control_owners: [],
  control_tags: [],
  export_result: null,
  isTranslationModalShown: false,
  translation_id: null,
  pendingTranslations: []
}

export default (state = defaultState, action) => {

  var newState = {...state, action_type: action.type}

  switch (action.type){
    case types.GET_LIBRARY_CONTROLS_REQUEST:
    case types.CREATE_LIBRARY_CONTROL_REQUEST:
    case types.UPDATE_LIBRARY_CONTROL_REQUEST:
    case types.ARCHIVE_LIBRARY_CONTROL_REQUEST:
    case types.UNARCHIVE_LIBRARY_CONTROL_REQUEST:
    case types.GET_CONTROL_OWNERS_REQUEST:
    case types.GET_CONTROL_TAGS_REQUEST:
    case types.EXPORT_LIBRARY_CONTROLS_TO_EXCEL.request:
      return newState;
    case types.GET_LIBRARY_CONTROLS_SUCCESS:
      newState.library_controls = action.body;
      return newState;
    case types.CREATE_LIBRARY_CONTROL_SUCCESS:
    case types.UPDATE_LIBRARY_CONTROL_SUCCESS:
    case types.ARCHIVE_LIBRARY_CONTROL_SUCCESS:
    case types.UNARCHIVE_LIBRARY_CONTROL_SUCCESS:
      newState.library_control = action.body;
      return newState;
    case types.GET_CONTROL_OWNERS_SUCCESS:
      newState.control_owners = action.body;
      return newState;
    case types.GET_CONTROL_TAGS_SUCCESS:
      newState.control_tags = action.body;
      return newState;
    case types.EXPORT_LIBRARY_CONTROLS_TO_EXCEL.success:
      newState.export_result = action.data;
      return newState;
    case types.GET_LIBRARY_CONTROLS_FAILURE:
    case types.CREATE_LIBRARY_CONTROL_FAILURE:
    case types.UPDATE_LIBRARY_CONTROL_FAILURE:
    case types.ARCHIVE_LIBRARY_CONTROL_FAILURE:
    case types.UNARCHIVE_LIBRARY_CONTROL_FAILURE:
    case types.GET_CONTROL_OWNERS_FAILURE:
    case types.GET_CONTROL_TAGS_FAILURE:
    case types.EXPORT_LIBRARY_CONTROLS_TO_EXCEL.failure:
      newState.exception = action.exception;
      return newState;
    case types.SHOW_TRANSLATION_MODAL:
      newState.isTranslationModalShown = true;
      newState.translation_id = action.translation_id
      return newState;
    case types.HIDE_TRANSLATION_MODAL:
      newState.isTranslationModalShown = false;
      newState.translation_id = null
      return newState;
    case types.PENDING_LIBRARY_CONTROL_TRANSLATION:
      // remove current library control from the list if already exists
      newState.pendingTranslations = (newState.pendingTranslations || []).filter(
        ({ library_control }) => library_control.custom_id !== action.library_control.custom_id
      );
      newState.pendingTranslations.push({
        library_control: action.library_control,
        timestamp: Date.now(),
        completedLanguages: []
      });
      return newState;
    case types.COMPLETED_LIBRARY_CONTROL_TRANSLATION:
      const currentIndex = newState.pendingTranslations.findIndex(
        ({ library_control }) => library_control.custom_id === action.library_control.custom_id
      );
      if(currentIndex < 0) return newState;
      
      if(action.language === "all") {
        newState.pendingTranslations.splice(currentIndex, 1)
      } else {
        newState.pendingTranslations[currentIndex].completedLanguages = newState.pendingTranslations[currentIndex].completedLanguages || []
        newState.pendingTranslations[currentIndex].completedLanguages.push(action.language.toLowerCase());
      }

      const libraryControl = newState.library_controls.find(
        ({ custom_id }) => custom_id === action.library_control.custom_id
      );

      if(libraryControl) {
        libraryControl.translations = action.library_control.translations;
      }
      return newState;
    case types.FAILED_LIBRARY_CONTROL_TRANSLATION:
      const failedLibraryControl = newState.pendingTranslations.find(
        ({ library_control }) => library_control.custom_id === action.library_control.custom_id
      );
      if(failedLibraryControl) {
        failedLibraryControl.type = "failed_translation";
      }
      return newState;
    default:  return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/library_control.js